module.exports = new __parcel__URL__("inglourious-basterds.63d541ad.jpg").toString();